var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "add_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19 10.95-6 .03-.03-6c0-.55-.45-1-1-1s-1 .45-1 1l.03 6-6 .03c-.55 0-1 .45-1 1s.45 1 1 1l6-.03.03 6c0 .55.45 1 1 1s1-.45 1-1l-.03-6 6-.03c.55 0 1-.45 1-1s-.45-1-1-1"
})));
export default SvgAdd;